// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__2YSi4","h2":"Heading_h2__1w0xA","h3":"Heading_h3__2sXuz","h4":"Heading_h4__c3gmk","h5":"Heading_h5__58n8s","h6":"Heading_h6__2K0gV"};